import React, { useState, useEffect } from "react";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import checkInNotCreatedImage from "assets/img/icons/check_in_not_created.png";
import checkInCreatedImage from "assets/img/icons/check_in_created.png";
import Loader from "components/Loader";
import * as moment from "moment";
import Button from "components/CustomButton";
import { useCreatePostContext } from "store/contexts/createPostContext";

var styles = {
  noMemberMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    color: "red",
    fontWeight: "400",
    textAlign: "center",
  },
  checkinButton: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 0px",
    flexDirection: "column",
    alignItems: "center",
  },
  message: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "10px 0px",
    fontSize: "1rem",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "15px 0px",
    width: "100%",
  },
  checkInHeading: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 0px",
  },
  checkInAvatar: {
    width: "56px",
    height: "56px",
  },
};

export default () => {
  const classes = styles;
  const { handleClose } = useCreatePostContext();
  const { team } = useTeamContext();
  const { createPost } = useTimelineContext();
  const [checkInCreated, setCheckInCreated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [lastCheckInTime, setLastCheckInTime] = useState();

  useEffect(() => {
    (async () => {
      try {
        var response = await TeamService.getCheckInLatestData(team.id);

        setLastCheckInTime(
          moment(response.data.data.last_checkin_time).format("HH:mm")
        );

        var endingTime = moment(
          response.data.data.next_checkin_available
        ).format();
        var presentTime = moment().format();

        if (
          presentTime < endingTime &&
          response.data.data.last_checkin_time !== null
        ) {
          setCheckInCreated(true);
        }

        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [team]);

  const initiateCheckIn = async () => {
    try {
      setLoading(true);
      var response = await TeamService.createCheckIn(team.id);
      setLastCheckInTime(moment().format("HH:mm"));
      setLoading(false);

      handleClose();
      createPost(response.data.data);
    } catch (e) {
      console.log(e);
    }
    setCheckInCreated(true);
  };

  return (
    <section style={classes.root} className="creatingPost">
      {team.users.length !== 1 && (
        <>
          <div style={classes.checkInHeading}>
            {!checkInCreated && (
              <img
                alt={"checkInNotCreated"}
                style={classes.checkInAvatar}
                src={checkInNotCreatedImage}
              />
            )}
            {!!checkInCreated && (
              <img
                alt={"checkInCreated"}
                style={classes.checkInAvatar}
                src={checkInCreatedImage}
              />
            )}
            <p style={{ fontSize: "1rem", margin: "0px 10px" }}>
              Your Check-in request will be sent to all team members
            </p>
          </div>
          <div style={classes.message}>
            <p>You can Initiate a new check-in request after every 24 hours.</p>
          </div>
          <div style={classes.checkinButton}>
            {checkInCreated && (
              <span style={{ color: "red", paddingBottom: "10px" }}>
                Last Check-in initiated at {lastCheckInTime}
              </span>
            )}
            <Button
              buttonClass={"light-gray-btn"}
              disabled={(checkInCreated || loading) && true}
              onClick={initiateCheckIn}
              name={
                !loading ? (
                  "Request a Check-in"
                ) : (
                  <Loader width={20} height={20} />
                )
              }
            />
          </div>
        </>
      )}
      {team.users.length === 1 && (
        <h6 style={classes.noMemberMessage}>
          Please add members in your team to initiate the check-in
        </h6>
      )}
    </section>
  );
};
